<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <v-toolbar :class="['toolbar-element', { 'presentation-content' : $store.state.miniLateralNav }]" light absolute flat height="100em">
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title toolbar-spacing">
          <div>{{ presentacion.nombre }}</div>
          <p v-if="!isPresentation && presentacion.estadoDisplay!=='En progreso'"
            class="small-text">
            {{descripcion }}
          </p>
          <div class="small-text">{{ expirationMessage }}</div>
          <v-card-actions class="small-text body-content" v-if="showSelectTemporada">
            Temporada:
            <v-select v-model="temporada"
                      :items="temporadas"
                      item-text="nombre"
                      item-value="pk"
                      no-data-text="No hay datos disponibles">
            </v-select>
          </v-card-actions>
        </v-toolbar-title>
      </template>
      <div class="description-container toolbar-title" v-if="this.draft || (this.presentacion.estadoDisplay==='En carga' && !this.isSafRole) && !isPresentation">
        <p class="small-text body-content">Descripción:</p>
        <v-text-field
        no-resize
        class="description-text-field"
        maxlength="60"
        variant="solo-filled"
        v-model="descripcion">
      </v-text-field>
      </div>
      <v-spacer></v-spacer>
      <component :is="currentActionButtons"
                 class="action-buttons"
                 :estado-permissions="estadoPermissions"
                 :can-submit="canSubmitActualizacion"
                 :temporada="temporada"
                 :descripcion="descripcion"
                 :draftIds="draftIds">
      </component>
    </v-toolbar>
    <!--    LateralTreeView-->
    <v-navigation-drawer fixed permanent class="navigator-tree" width="400" v-show="$store.state.miniLateralNav">
      <v-toolbar color="#355487" flat class="white--text">
        <v-list-tile-content>
          <v-list-tile-title class="club-text custom-font-regular" v-if="isSafRole">Club {{ clubName }}</v-list-tile-title>
          <v-list-tile-sub-title class="club-sub-text custom-font-regular">{{ presentacion.nombre }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-spacer></v-spacer>
        <v-btn small light @click="seeHistory" class="history-button blue--text" v-if="!hideHistory">
          <v-icon small color="blue" class="icon-build">history</v-icon>
          <span>Historial</span>
        </v-btn>
      </v-toolbar>
      <v-layout row wrap v-if="!draft">
        <v-flex xs12>
          <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
          <v-card color="#355487" flat class="white--text">
            <v-card-actions class="status-percentage">
              <span v-if="subsanada" class="custom-font-semi-bold status-text">{{ "SUBSANADA" }}</span>
              <span  v-else class="custom-font-semi-bold status-text">{{ presentacion.estadoDisplay.toUpperCase() }}</span>
              <v-spacer></v-spacer>
              <PresentacionProgressCircular :criterios="criterios" :showCorrected="showCorrectedPercentage"></PresentacionProgressCircular>
            </v-card-actions>
          </v-card>
          <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-divider color="lightgrey" class="toolbar-divider"></v-divider>
      </v-layout>

      <v-card color="#355487" flat>
        <v-card-text>
          <div class="custom-font-regular" v-if="isSafRole && unsettedExpirationCriteria">
            <v-icon small color="orange lighten-1" class="mr-1">error</v-icon>
            <span class="orange--text">{{ expirationAlertMessage }}</span>
          </div>

          <v-spacer></v-spacer>
          <v-layout row wrap align-center>
            <v-flex xs8 sm8 md8>
              <v-text-field v-model="search" label="Buscar Criterio..." dark flat class="search-bar pa-0 dense-text-field" solo-inverted
                            hide-details clearable clear-icon="mdi-close-circle-outline" height="35"></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-btn-toggle v-model="toggle_multiple" depressed multiple class="transparent">
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="green lighten-1" slot="activator">check_circle</v-icon>
                    <span>Revisado ok</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="red lighten-1" slot="activator">error</v-icon>
                    <span>Revisado incompleto</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon small color="yellow darken-3" slot="activator">pause_circle_filled</v-icon>
                    <span>A Revisar</span>
                  </v-tooltip>
                </v-btn>
                <v-btn flat @click="fireUpdate">
                  <v-tooltip bottom>
                    <v-icon  small color="yellow darken-3" slot="activator">edit</v-icon>
                    <span>No presentado</span>
                  </v-tooltip>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-treeview
                  :key="componentKey"
                  :items="items"
                  :search="search"
                  :filter="filter"
                  item-key="pk"
                  item-text="title"
                  :open.sync="open"
                  :active.sync="active"
                  :open-all="true"
                  open-on-click
                  transition
                  activatable
                  active-class="info--text"
                  class="custom-font-regular white--text white-icon">
            <template slot="prepend" slot-scope="props">
              <StatusIcon :status="props.item.estadoDisplay"></StatusIcon>
              <ExpirationIcon :criterion="props.item"></ExpirationIcon>
            </template>
          </v-treeview>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <!--    LateralTreeView-->

    <v-flex :class="{ 'presentation-content':$store.state.miniLateralNav }" mt-5 pt-2>
      <CriterioDetailTreeView :estados-requerimientos="estadosRequerimiento" :criterio="criterio"
                              @updateRequerimiento="updateAfterRequest"
                              @updateCriterionExpiration="updateCriterionExpiration"
                              :draft="draft" :is-ficha="draft">
      </CriterioDetailTreeView>
    </v-flex>
    <HistoryDialog ref="history" :history="history" :subsanada="wasSubsanada" v-if="!hideHistory"></HistoryDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import store from '../../../app/store'
import StatusIcon from '../../presentacion//components/StatusIcon'
import ExpirationIcon from '../../presentacion/components/ExpirationIcon'
import HistoryDialog from '../../presentacion/components/HistoryDialog'
import CriterioDetailTreeView from '../../presentacion/components/CriterioDetailTreeView'
import PresentacionProgressCircular from '../../presentacion//components/PresentacionProgressCircular'
import PresentacionActionButtonsSaf from '../../presentacion//components/PresentacionActionButtonsSaf'
import PresentacionActionButtonsClub from '../../presentacion//components/PresentacionActionButtonsClub'
import PresentacionUpdateActionButtonsSaf from '../../presentacion_update/components/PresentacionUpdateActionButtonsSaf'
import PresentacionUpdateActionButtonsClub from '../../presentacion_update/components/PresentacionUpdateActionButtonsClub'
import PresentacionDraftActionButtonsClub from '../../presentacion_draft/components/PresentacionDraftActionButtonsClub'
import Constants from '../../../common/constants'

const NO_PRESENTADO = Constants.NO_PRESENTADO
const REVISADO_INCOMPLETO = Constants.REVISADO_INCOMPLETO
const REVISADO_OK = Constants.REVISADO_OK
const A_REVISAR = Constants.A_REVISAR

export default {
  mixins: [validationMixin],

  props: {
    path: {
      type: String,
      default: 'frontend/presentacion/'
    },
    actionButtonsPrefix: {
      type: String,
      default: 'PresentacionActionButtons'
    },
    hideHistory: Boolean,
    draft: Boolean
  },

  components: {
    StatusIcon,
    ExpirationIcon,
    HistoryDialog,
    CriterioDetailTreeView,
    PresentacionProgressCircular,
    PresentacionActionButtonsSaf,
    PresentacionActionButtonsClub,
    PresentacionUpdateActionButtonsSaf,
    PresentacionUpdateActionButtonsClub,
    PresentacionDraftActionButtonsClub
  },

  validations () {
    return {
      temporada: { required: requiredIf(() => { return this.showSelectTemporada }) },
      descripcion: { required: requiredIf(() => { return this.hasDescription }) }
    }
  },

  data () {
    return {
      items: [],
      open: [],
      active: [],
      club: {},
      clubName: '',
      criterio: {},
      loading: true,
      history: [],
      subsanada: false,
      presentacion: {},
      estadoPermissions: {},
      estadosRequerimiento: [],
      search: null,
      toggle_multiple: [0, 1, 2, 3],
      filterSelection: [REVISADO_OK, REVISADO_INCOMPLETO, A_REVISAR, NO_PRESENTADO],
      componentKey: 0,
      temporada: null,
      temporadas: [],
      descripcion: '',
      isPresentation: null,
      draftIds: []
    }
  },

  computed: {
    ...mapGetters(['isSafRole', 'role']),
    criterios () {
      return this.getCriterios()
    },
    wasSubsanada () {
      const aSubsanar = this.history.find(item => item.estado === 'A subsanar')
      return aSubsanar !== undefined
    },
    filter () {
      return (item, search, textKey) => {
        const found = item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1

        return found
          ? this.toggle_multiple.some(filterIndex => item.estadoDisplay === this.filterSelection[filterIndex])
          : false
      }
    },
    currentActionButtons () {
      return this.actionButtonsPrefix + this.role
    },
    unsettedExpirationCriteria () {
      return this.getCriterios().reduce((total, criterio) => {
        return (this.criterioHasUnsettedExpiration(criterio)) ? total + 1 : total
      }, 0)
    },
    expirationAlertMessage () {
      let letterS = (this.unsettedExpirationCriteria > 1) ? 's' : ''
      return `${this.unsettedExpirationCriteria} criterio${letterS} Revisado ok, pero sin vencimiento asignado`
    },
    expirationMessage () {
      if (!this.presentacion.hasOwnProperty('daysToExpire')) return ''
      let daysToExpire = this.presentacion.daysToExpire
      if (daysToExpire <= 0) {
        return `Vencida el ${this.presentacion.fechaVencimiento}`
      }
      let letterS = (daysToExpire === 1) ? '' : 's'
      let letterN = (daysToExpire === 1) ? '' : 'n'
      return `Vence el ${this.presentacion.fechaVencimiento} (resta${letterN} ${daysToExpire} día${letterS} corrido${letterS})`
    },
    showCorrectedPercentage () {
      return this.isSafRole && ![Constants.EN_CARGA, Constants.A_SUBSANAR].includes(this.presentacion.estadoDisplay)
    },
    showSelectTemporada () {
      return this.draft
    },
    canSubmitActualizacion () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    hasDescription () {
      return this.draft
    }
  },

  methods: {
    fireUpdate () {
      this.search = Object.assign('', this.search)
    },
    getCriterios () {
      return this.items.flatMap(area => area.children.flatMap(subarea => subarea.children))
    },
    getCriterio (id) {
      return this.getCriterios().find(criterion => criterion.pk === id)
    },
    criterioHasUnsettedExpiration (criterio) {
      let hasStatusForApprove = (criterio.estadoDisplay === REVISADO_OK || criterio.estadoDisplay === NO_PRESENTADO)
      return criterio.expire && !criterio.expiration.date && hasStatusForApprove
    },
    fetchCriterio () {
      this.criterio = this.getCriterio(this.active[0])
    },
    addProperty (object, newProp, copyObject, copyProp) {
      Object.defineProperty(object, newProp, Object.getOwnPropertyDescriptor(copyObject, copyProp))
    },
    renameProperty (object, oldProp, newProp) {
      this.addProperty(object, newProp, object, oldProp)
      delete object[oldProp]
    },
    formatPresentationForTreeView () {
      for (let area of this.items) {
        this.renameProperty(area, 'subareas', 'children')
        for (let subarea of area.children) {
          this.renameProperty(subarea, 'criterios', 'children')
          for (let criterio of subarea.children) {
            this.addProperty(criterio, 'title', criterio, 'nombre')
          }
        }
      }
    },
    initOpenTabs () {
      let firstArea = this.items[0]
      let firstSubarea = firstArea.children[0]
      this.open[0] = firstArea.pk
      this.open[1] = firstSubarea.pk
      this.active[0] = firstSubarea.children[0].pk
    },
    updateAfterRequest (response) {
      this.axios
        .get('draft')
        .then(responseComplete => {
          this.updateAfterRequestDraft(responseComplete)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    updateAfterRequestDraft (response) {
      if (response.status === 204) {
        this.$store.commit('setDraft', null)
        this.$router.push({ name: 'actualizaciones' })
      } else {
        this.setDraft(response)
        this.fetchCriterio()
      }
    },
    setDraft (response) {
      let originalResponse = { ...response.data }
      let draftIds = Object.values(originalResponse).map((item) => item.pk)
      this.draftIds = draftIds.map((pk) => parseInt(pk))
      // patron adapter para data drafts
      const dataAdapter = this.transformData(response.data)
      this.presentacion = { nombre: dataAdapter.nombre, descripcion: dataAdapter.descripcion, estadoDisplay: dataAdapter.estadoDisplay, draft: dataAdapter.draft }
      this.items = dataAdapter.draft
      this.formatPresentationForTreeView()
      this.initOpenTabs()
    },
    updateCriterionExpiration (data) {
      this.estadoPermissions = data.presentationStatus
      this.getCriterio(data.pk).expiration = data.expiration
    },
    seeHistory () {
      this.$refs.history.showDialog()
    },
    fetchDraft () {
      this.axios
        .get('draft')
        .then(response => {
          this.setDraft(response)
          this.fetchSeasons()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchSeasons () {
      this.axios
        .get('seasons')
        .then(response => {
          this.temporadas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    transformData (apiData) {
      const combinedData = {
        draft: [],
        estadoDisplay: '',
        nombre: '',
        descripcion: null
      }

      apiData.forEach((item) => {
        combinedData.draft = combinedData.draft.concat(item.draft)
        combinedData.estadoDisplay = item.estadoDisplay
        combinedData.nombre = item.nombre
        combinedData.descripcion = item.descripcion
      })

      return combinedData
    }
  },

  mounted () {
    this.fetchDraft()
  },

  watch: {
    'active' () {
      if (this.active.length) {
        this.fetchCriterio()
      } else {
        this.active[0] = this.criterio.pk
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    store.commit('hideLateralNav')
    next()
  }
}
</script>

<style scoped>
  .navigator-tree {
    margin-left: 5.7em;
    background-color: #355487;
    margin-top: 4.6em !important;
    padding-top: 1em;
    padding-bottom: 6em;
  }
  .percentage-charged {
    margin-left: 1em;
    color: lightgrey;
  }
  .toolbar-divider {
    margin: 0 1em 0 1em;
  }
  .status-percentage {
    padding: 0.5em 1.8em 0.5em 1.8em;
  }
  .club-text {
    font-weight: bold;
    font-size: 1.4em;
  }
  .club-sub-text {
    font-size: 1em;
  }
  .presentation-content {
    padding-left: 27.5em !important;
  }
  .custom-font-regular {
    font-family: SourceSansProRegular, sans-serif;
  }
  .custom-font-semi-bold {
    font-family: SourceSansProSemiBold, sans-serif;
  }
  .toolbar-spacing {
    margin-left: 0.6em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .small-text {
    font-size: 0.5em;
    padding-left: 0.1em;
  }
  .history-button {
    font-size: 0.9em;
  }
  .icon-build {
    margin-right: 0.3em;
  }
  .v-progress-circular {
    margin-left: 5px;
    height: 30px !important;
  }
  .v-btn-toggle--selected {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .body-content {
    padding: 1px;
  }
  .description-container{
    display: flex;
    align-items: center;
    margin-top: 46px;
    margin-left: 1em;
  }
  .description-container > p{
    margin-bottom: 0;
    font-size: 15.4px;
  }
  .description-subtitle{
   font-size: 16px;
  }
  .description-text-field{
    margin-left: 5px;
    width: 300px;
  }
</style>
